export const DEFAULT_AUTOSUGGEST_RESULT_SIZE = 5;
export const NO_RESULT_FOUND_MESSAGE = 'No results found. Please try new search terms.';

export const SEARCH_SHORT_PLACEHOLDER = 'Search...';
export const SEARCH_LONG_PLACEHOLDER = 'Find equipment and solutions...';

export const SEARCH_DEFAULT_DEBOUNCE_TIME = 150;
